import z from "zod"

export const reportingFrequencyTriggersEnum = z.enum(
  ["individual_date", "fixed_hours", "hard_date", "hard_cycle"],
  {
    message: "Frequentie trigger is verplicht",
  },
)

export type ReportingFrequencyTrigger = z.infer<
  typeof reportingFrequencyTriggersEnum
>

export const reportingFrequencyTriggerOptions: {
  value: ReportingFrequencyTrigger
  label: string
}[] = [
  { value: "individual_date", label: "Individuele datum" },
  { value: "fixed_hours", label: "Vast uren schema" },
  { value: "hard_date", label: "Vaste datum" },
  { value: "hard_cycle", label: "Vaste cyclus" },
]

export const reportingFrequencyRouteOptions: {
  value: ReportingFrequencyTrigger
  label: string
}[] = [
  { value: "hard_cycle", label: "B1 Route" },
  { value: "hard_date", label: "Z-Route" },
  { value: "individual_date", label: "B1 Route Entree" },
]

export const reportingFrequencyTriggerMap: Record<
  ReportingFrequencyTrigger,
  string
> = {
  individual_date: "Individuele datum",
  fixed_hours: "Vast uren schema",
  hard_date: "Vaste datum",
  hard_cycle: "Vaste cyclus",
}

export const reportingTimeUnitsEnum = z.enum(
  [
    "days_after_first_lesson",
    "weeks_after_first_lesson",
    "months_after_first_lesson",
    "hours_attended",
    "hours_offered",
    "day_of_week",
    "day_of_month",
    "day_of_quarter",
    "days",
    "weeks",
    "months",
  ],
  {
    message: "Tijdseenheid is verplicht",
  },
)

export type ReportingTimeUnit = z.infer<typeof reportingTimeUnitsEnum>

export const reportingTimeUnitOptions: {
  value: ReportingTimeUnit
  label: string
}[] = [
  { value: "days_after_first_lesson", label: "Dagen na eerste les" },
  { value: "weeks_after_first_lesson", label: "Weken na eerste les" },
  { value: "months_after_first_lesson", label: "Maanden na eerste les" },
  { value: "hours_attended", label: "Gevolgde uren" },
  { value: "hours_offered", label: "Aangeboden uren" },
  { value: "day_of_week", label: "Dag van de week" },
  { value: "day_of_month", label: "Dag van de maand" },
  { value: "day_of_quarter", label: "Dag van het kwartaal" },
  { value: "days", label: "Dagen" },
  { value: "weeks", label: "Weken" },
  { value: "months", label: "Maanden" },
]

export function getReportingTimeUnitOptions(
  trigger?: ReportingFrequencyTrigger | null,
): {
  value: ReportingTimeUnit
  label: string
}[] {
  switch (trigger) {
    case "individual_date":
      return [
        { value: "days_after_first_lesson", label: "dagen na eerste les" },
        { value: "weeks_after_first_lesson", label: "weken na eerste les" },
        { value: "months_after_first_lesson", label: "maanden na eerste les" },
      ]
    case "fixed_hours":
      return [
        { value: "hours_attended", label: "gevolgde uren" },
        { value: "hours_offered", label: "aangeboden uren" },
      ]
    case "hard_date":
      return [
        { value: "day_of_week", label: "van de week" },
        { value: "day_of_month", label: "van de maand" },
        { value: "day_of_quarter", label: "van het kwartaal" },
      ]
    case "hard_cycle":
      return [
        { value: "days", label: "dagen" },
        { value: "weeks", label: "weken" },
        { value: "months", label: "maanden" },
      ]
    default:
      return []
  }
}
